import { localPropertiesService } from '@/services/local-properties/local-properties.service'

const WIDTH_KEY = 'DIALOG_WIDTH'
const HEIGHT_KEY = 'DIALOG_HEIGHT'

const readSizeMap = (key: string): Record<string, number> => {
  const raw = localPropertiesService.get(key)
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) {
    return {}
  }
  return raw as Record<string, number>
}

export const loadSavedDialogSize = (
  formId: string | number | null | undefined,
): { widthPx: number | null; heightPx: number | null } => {
  if (formId == null || formId === '') {
    return { widthPx: null, heightPx: null }
  }

  const id = String(formId)
  const widths = readSizeMap(WIDTH_KEY)
  const heights = readSizeMap(HEIGHT_KEY)
  const savedWidth = widths[id]
  const savedHeight = heights[id]

  return {
    widthPx: typeof savedWidth === 'number' && savedWidth > 0 ? savedWidth : null,
    heightPx: typeof savedHeight === 'number' && savedHeight > 0 ? savedHeight : null,
  }
}

export const saveDialogSize = (
  formId: string | number,
  widthPx: number,
  heightPx: number | null,
): void => {
  const id = String(formId)
  const widths = readSizeMap(WIDTH_KEY)
  const heights = readSizeMap(HEIGHT_KEY)

  widths[id] = widthPx
  if (heightPx != null && heightPx > 0) {
    heights[id] = heightPx
  } else {
    delete heights[id]
  }

  localPropertiesService.set(WIDTH_KEY, widths)
  localPropertiesService.set(HEIGHT_KEY, heights)
  localPropertiesService.saveAll()
}
